// import { Notification, StylesScene } from '../../../models'
import * as CommonTypes from '../actionTypes/commonTypes'
import * as LinkTypes from '../actionTypes/linkTypes'
import * as TaskTypes from '../actionTypes/taskTypes'
import * as MustReadTypes from '../actionTypes/mustReadTypes'
import * as MoveItemTypes from '../actionTypes/moveItemTypes'
import * as commonTypesResolvers from './commonTypes'
import * as linkTypesResolvers from './linkTypes'
import * as taskTypesResolvers from './taskTypes'
import * as mustReadTypesResolvers from './mustReadTypes'
import { Notification } from '../../../models/Notification'
import { StylesScene } from '../../../models/Story'


type Resolver = (notif: Notification) => [string, StylesScene]
interface DictionaryResolvers { [key: string]: Resolver }

const dictionary: DictionaryResolvers = {
    [CommonTypes.UserAddItem]: commonTypesResolvers.getUserAddItemBackground,
    [CommonTypes.UserAddComment]: commonTypesResolvers.getUserAddCommentBackground,
    [MustReadTypes.UserReadItem]: mustReadTypesResolvers.getUserReadItemBackground,
    [MustReadTypes.UserAskedToReadItem]: mustReadTypesResolvers.getUserAskedtoreadItemBackground,
    [LinkTypes.UserLinkedItem]: linkTypesResolvers.getUserLinkItemBackground,
    [TaskTypes.UserAddTask]: taskTypesResolvers.getUserAddTaskBackground,
    [TaskTypes.UserDoneTask]: taskTypesResolvers.getUserDoneTaskBackground,
    [TaskTypes.UserDoneDueDateTask]: taskTypesResolvers.getUserDoneDuedateTaskBackground,
    [MoveItemTypes.UserMoveItemLane]: commonTypesResolvers.getUserMovedItemBackground,
}

//use for additional data(signiture)
export const resolveSceneBackground = (notif: Notification): [string, StylesScene] => {
    const resolver: Resolver = dictionary[notif.systemActionTypeUid]
    return resolver(notif)
}